import { SET_SIDEBAR_WIDTH } from './constants';

export const setSidebarWidth = width => ({
  type: SET_SIDEBAR_WIDTH,
  width,
});
